<template>
  <div class="minimap" v-show="toggleMinimap" >
    <div class="mask"></div>
    <div class="minimap-wrap"  :style="minimapClz">
      <seating-chart :isMinimap="true"> </seating-chart>
      <div class="focus" :style="focusStyle">
      </div>
    </div>
  </div>
</template>


<script>
  import { mapState, mapGetters } from 'vuex'

  import SeatingChart from './seating_chart'

  const MINIMAP_DEFAULT_WIDTH = 116
  const MINIMAP_DEFAULT_HEIGHT = 113


  const SEAT_DEFAULT_WIDTH = 25
  const SEAT_DEFAULT_HEIGHT = 25

  const DEFAULT_MARGIN_BOTTOM = 95
  const DEFAULT_MARGIN_TOP = 118

  let myInterval = null
  let newNow = 0
  export default {
    props: {
      score: Number,
    },
    components: {
      'seating-chart': SeatingChart,
    },
    computed: {
      ...mapGetters([
        'getPreorderSelectedSeats',
      ]),
      focusStyle() {
        let tInfo = this.$store.state.schedule.seatingChartTransform
        const {x, y , k} = tInfo

        const chartWidth = this.seatingChart.width * SEAT_DEFAULT_WIDTH
        const chartHeight = this.seatingChart.height * SEAT_DEFAULT_HEIGHT
        const wrapperHeight = document.body.scrollHeight - DEFAULT_MARGIN_TOP - DEFAULT_MARGIN_BOTTOM
        let wrapperWidth =  document.body.clientWidth
        const left = (chartWidth > wrapperWidth ? (chartWidth - wrapperWidth) / 2 : 0)

        // 最好不要动！！
        const ret = {
          top: (0 - y) / k + 'px',
          left: (left - x) / k + 'px',
          width: (chartWidth - (left * 2)) / k + 'px',
          height: wrapperHeight / k + 'px',
        }
        return ret
      },
      minimapClz() {
        const k = MINIMAP_DEFAULT_WIDTH / this.chartWidth
        const tleft = MINIMAP_DEFAULT_WIDTH * (1 - k) / 2
        const ttop = MINIMAP_DEFAULT_HEIGHT * (1 - k) / 2
        return {
          transform: `translate(${-tleft}px, ${-ttop}px) scale(${k})`,
          '-webkit-transform': `translate(${-tleft}px, ${-ttop}px) scale(${k})`
        }
      },
      seatingChart() {
        return this.$store.state.schedule.seatingChart
      },
      transformInfo() {
        return this.$store.state.schedule.seatingChartTransform
      },
    },
    watch: {
      seatingChart(nv, ov) {
        this.chartWidth = this.seatingChart.width * SEAT_DEFAULT_WIDTH
        this.chartHeight = this.seatingChart.height * SEAT_DEFAULT_HEIGHT
      },
      transformInfo(nv, ov) {
        this.checkShowMinimap()
      },
      getPreorderSelectedSeats(nv, ov) {
        this.checkShowMinimap()
      }
    },
    methods: {
      checkShowMinimap() {
        this.toggleMinimap = true
        clearInterval(myInterval)
        myInterval = null
        myInterval = setInterval(() => {
          this.toggleMinimap = false
          clearInterval(myInterval)
          myInterval = null
        }, 2000);
      }
    },
    data() {
      return {
        scaleK: 0,
        chartHeight: 275,
        chartWidth: 650,
        toggleMinimap: false,
      }
    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';

.minimap {
  position: absolute;
  left: 0;
  height: 113px;
  width: 116px;
  overflow: hidden;
  .minimap-wrap {
    z-index: 4;
    height: 100%;
    width: 100%;
    position: relative;
    .seating-chart-wrap {
      overflow: initial;
    }
    .focus {
      position: absolute;
      border: 1px solid #fe8233;
      background-color: rgba(254,130,51,0.18);
    }
  }
  .mask {
    position: absolute;
    left: 0;
    height: 113px;
    width: 116px;
    z-index: 3;
    opacity: 0.5;
    background: @darkGrey;
  }
}
</style>


